var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92867 18.6875C4.43159 18.6875 3.97799 18.2846 4.00083 17.7579C4.13467 14.6737 4.50963 12.666 5.56017 11.0777C6.16457 10.1639 6.91531 9.36918 7.77847 8.72936C10.1115 7 13.4028 7 19.9853 7H28.0148C34.5972 7 37.8886 7 40.2216 8.72936C41.0848 9.36918 41.8354 10.1639 42.4398 11.0777C43.4904 12.6658 43.8654 14.6733 43.9992 17.7569C44.022 18.2842 43.5678 18.6875 43.0702 18.6875C40.2986 18.6875 38.0518 21.066 38.0518 24C38.0518 26.934 40.2986 29.3124 43.0702 29.3124C43.5678 29.3124 44.022 29.7158 43.9992 30.2432C43.8654 33.3268 43.4904 35.3342 42.4398 36.9224C41.8354 37.836 41.0848 38.6308 40.2216 39.2706C37.8886 41 34.5972 41 28.0148 41H19.9853C13.4028 41 10.1115 41 7.77847 39.2706C6.91531 38.6308 6.16457 37.836 5.56017 36.9224C4.50963 35.334 4.13467 33.3262 4.00083 30.2422C3.97799 29.7154 4.43159 29.3124 4.92867 29.3124C7.70025 29.3124 9.94705 26.934 9.94705 24C9.94705 21.066 7.70025 18.6875 4.92867 18.6875Z",
    stroke: "#077882",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7V41",
    stroke: "#077882",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTicket);
export default __webpack_public_path__ + "static/media/noTicket.3d1003572a020f4d8f9de96b251b75c4.svg";
export { ForwardRef as ReactComponent };